import { useNavigate } from 'react-router-dom'
import './index.css'
import { Box, Grid, Typography } from '@mui/material'
import PasswordBox from './password'
import Button from 'components/Common/Button'
import { useState, useContext } from 'react'
import { DISABLED_BUTTON, PRIMARY_BUTTON } from 'themes/theme'
import { AuthStateContext } from 'context/auth'
import api from 'api'
import { validatePassword } from 'utils/helper'
import ZendeskLink from 'components/Common/ZendeskLink'

const PasswordVerifyMob = () => {
  const navigate = useNavigate()
  const [password, setPassword] = useState()
  const [confirmPassword, setConfirmPassword] = useState()
  const [authState, authDispatch] = useContext(AuthStateContext)
  const [inValid, setInvalid] = useState()
  const [pwdinValid, setPwdinValid] = useState()
  const handlePwdKey = e => {
    const { value } = e.target
    if (!value) {
      setPwdinValid('This Field is required')
    } else if (password.length < 8) {
      setPwdinValid('Password must be at least 8 characters')
    } else if (password.search(/[a-z]+/) < 0) {
      setPwdinValid('Password requires lowercase letters')
    } else if (password.search(/[A-Z]+/) < 0) {
      setPwdinValid('Password requires uppercase letters')
    } else if (password.search(/[0-9]+/) < 0) {
      setPwdinValid('Password requires numbers')
    } else if (password.search(/[!@#$%^&*)(+=.<>{}/[\\\]:;'"|~`_-]+/) < 0) {
      setPwdinValid('Password requires special characters')
    } else {
      setPwdinValid(false)
    }
  }
  const handleKey = e => {
    const { value } = e.target
    if (!value) {
      setInvalid('This Field is required')
    } else if (password !== confirmPassword) {
      setInvalid('Passwords must match')
    } else {
      setInvalid(false)
    }
  }
  const handleSubmit = e => {
    e.preventDefault()
    authDispatch({
      type: 'signIntoSignUpMob',
      payload: {
        email: authState.email.toLowerCase(),
        firstName: authState.firstName,
        lastName: authState.lastName,
        password: password,
      },
    })
    api.signUp(authState?.email.toLowerCase(), password, authState?.firstName, authState?.lastName)
    navigate('/auth/mobile/verify-otp')
  }
  return (
    <Box
      height="100%"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      display="flex"
      color="#66668F"
      marginTop="46px"
      textAlign="center"
    >
      <Typography variant="h6" margin="40px 0px" color="#25245f">
        Almost done!
        <br />
        Create a password
      </Typography>
      <Box onSubmit={handleSubmit} className="mt-3" component="form">
        <Box className="my-3 authForm" paddingX="50px">
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box className={`my-3 authForm ${pwdinValid ? 'inValid' : ''}`}>
                <PasswordBox
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Password"
                  style={{ padding: '13px 15px', fontSize: '16px' }}
                  name="password"
                  onKeyUp={handlePwdKey}
                />
                <Box
                  className="errorMessage mt-1"
                  justifyContent="start"
                  display="flex"
                  fontSize="12px"
                  fontWeight={400}
                  color="#D14343"
                >
                  {pwdinValid}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box className={`my-3 authForm ${inValid ? 'inValid' : ''}`}>
                <PasswordBox
                  onChange={e => setConfirmPassword(e.target.value)}
                  placeholder="Confirm Your Password"
                  style={{ padding: '13px 15px', marginTop: '10px', fontSize: '16px' }}
                  name="confirmPassword"
                  onKeyUp={handleKey}
                />
                <Box
                  className="errorMessage mt-1"
                  justifyContent="start"
                  display="flex"
                  fontSize="12px"
                  fontWeight={400}
                  color="#D14343"
                >
                  {inValid}
                </Box>
              </Box>
            </Grid>
            <Typography variant="caption" marginTop="20px">
              Must be at least 8 characters and contain one uppercase letter, one lowercase letter, one number and one
              special character (e.g., ! # $ %)
            </Typography>
          </Grid>
        </Box>
        <Box display="flex" justifyContent="center">
          <Button
            type={validatePassword(password) && password === confirmPassword ? PRIMARY_BUTTON : DISABLED_BUTTON}
            style={{ width: '250px', height: '50px', margin: '40px' }}
            submit
          >
            Continue
          </Button>
        </Box>
        <Box marginBottom="40px">
          <Typography variant="caption">
            Already have an account?
            <br />
            Please go to your desktop to sign in.
          </Typography>
        </Box>
      </Box>
      <Box margin="40px">
        <Typography variant="caption">
          By creating an account, I acknowledge I have read, understand, and agree to the Markaaz’s&nbsp;
          <a rel="noreferrer" className="authLinkMob" href="https://markaaz.com/terms-and-conditions" target="_blank">
            Terms and Conditions
          </a>
          , including the arbitration, limitation of liability, and class waiver provisions. I also confirm I have read
          and understand the Markaaz &nbsp;
          <a rel="noreferrer" className="authLinkMob" href="https://markaaz.com/privacy/" target="_blank">
            Privacy Policy
          </a>
          .
        </Typography>
      </Box>
      <ZendeskLink />
    </Box>
  )
}

export default PasswordVerifyMob
